<template>
  <div v-if="user">
    <div class="container">
      <Toolbar class="mt-2 mb-2">
        <template #start>
          <h2>{{ $t("nav.userDetail") }}</h2>
        </template>

        <template #end>
          <div v-if="user.role === contactRole">
            <Button
              class="p-button-rounded p-button-outlined"
              :label="$t('userdetailpage.showappointments')"
              @click="$router.push({name: 'userAppointment', params: {userId: user.id}})"
            />
          </div>
          <Button
            :label="$t('action.back')"
            icon="pi pi-arrow-left"
            class="p-button-secondary p-button-rounded p-button-outlined"
            @click="toUserTable"
          />
        </template>
      </Toolbar>

      <Panel
        v-if="user.stakeholder &&
          user.stakeholder.stakeholderId"
        class="mb-3"
      >
        <template #header>
          <p class="font-bold">
            {{ $t('userdetailpage.fieldset.stakeholder') }}
          </p>
        </template>
        <div class="card_details ">
          <div class="card_body">
            <ul class="flex justify-content-between">
              <li
                v-if="user.stakeholder &&
                  user.stakeholder.stakeholderId"
              >
                {{ $t('entity.user.stakeholderId') }} : <strong>{{ user.stakeholder
                  &&
                  user.stakeholder.stakeholderId }}</strong>
              </li>
            </ul>
          </div>
        </div>
      </Panel>

      <Panel>
        <template #header>
          <p class="font-bold">
            {{ $t('userdetailpage.fieldset.contact') }}
          </p>
        </template>
        <div class="card_details ">
          <div class="card_body">
            <ul class="flex justify-content-between">
              <li>
                <div class="address">
                  <ul>
                    <li>{{ $t('entity.user.lastname') }} : <strong>{{ user.lastname }}</strong></li>
                    <li> {{ $t('entity.user.email') }} : <strong>{{ user.email }}</strong></li>
                    <li v-if="user.phoneNumber">
                      {{ $t('entity.user.phoneNumber') }} : <strong>{{ formatPhoneNumberAsInternational(user.phoneNumber, user.phoneNumberCountryCode)
                      }}</strong>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <ul>
                  <li> {{ $t('entity.user.firstname') }} : <strong>{{ user.firstname }}</strong></li>
                  <li v-if="user.company">
                    {{ $t('entity.user.company') }} : <strong>{{ user.company }}</strong>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </Panel>

      <Panel class="mt-3 mb-3">
        <template #header>
          <p class="font-bold">
            {{ $t('userdetailpage.fieldset.account') }}
          </p>
        </template>
        <div class="card_details ">
          <div class="card_body">
            <ul class="flex justify-content-between">
              <li> {{ $t('userdetailpage.role') }} : <strong> {{ getRole(user.role) }}</strong></li>
              <li>
                {{ $t('userdetailpage.account.state') }} : <strong> {{
                  user.activated ? $t('userdetailpage.account.activate') : $t('userdetailpage.account.desactivate')
                }}</strong>
              </li>
            </ul>
            <ul class="flex justify-content-between">
              <li> {{ $t('entity.user.approver') }} : <strong> {{ user.approver ? $t('action.yes') : $t('action.no') }}</strong></li>
              <li>
                {{ $t('userdetailpage.approved') }} : <strong> {{ user.approved ? $t('action.yes') : $t('action.no') }}</strong>
              </li>
            </ul>
            <ul class="flex justify-content-between">
              <li v-if="user.approvalDate">
                {{ $t('entity.user.approvalDate') }} : <strong> {{ user.approvalDate }}</strong>
              </li>
              <li v-if="user.rejectMessage">
                {{ $t('entity.user.rejectMessage') }} : <strong> {{ user.rejectMessage }}</strong>
              </li>
            </ul>
          </div>
        </div>
      </Panel>
    </div>
  </div>
</template>

<script>
import {ADMIN_ROLE, AGENT_ROLE, CONTACT_ROLE} from "@/shared/constants";
import Button from "primevue/button";
import Toolbar from "primevue/toolbar";
import Panel from "primevue/panel";
import {formatPhoneNumberAsInternational} from "@/shared/utils/phoneNumberUtils";

export default {
  name: 'UserDetail',
  components: { Button, Toolbar, Panel },
  data() {
    return {
      user: null,
      error: '',
    }
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    contactRole() {
      return CONTACT_ROLE;
    },
  },
  async mounted() {
    try {
      this.user = await this.$userService.getUser(this.id)
      if (!this.user) await this.$router.push("/user")
    } catch (e) {
      await this.$router.push("/user")
    }
  },
  methods: {
    formatPhoneNumberAsInternational,
    getRole(role) {
      switch (role) {
        case CONTACT_ROLE:
          return this.$t('userdetailpage.roles.contact')
        case AGENT_ROLE:
          return this.$t('userdetailpage.roles.agent')
        case ADMIN_ROLE:
          return this.$t('userdetailpage.roles.admin')
      }
    },
    toUserTable() {
      this.$router.push({ name: 'user' })
    }
  }
}
</script>

<style lang="scss" scoped>
span {
  float: right;
}

.card_details {
  span {
    float: none;
  }

  ul,
  ol {
    list-style: none;
    padding: 0;
  }

  .card_header {
    .card_times {
      background: #f7f7f7;
      padding: 10px;
      font-weight: 600;
    }
  }

  .card_body {
    li {
      width: 25vw;
      padding: 5px 0;
    }

  }
}

::v-deep(div.p-panel-header) {
  padding: 0 1rem;
}

::v-deep(div.p-panel-content) {
  padding: 0.1rem 1rem;
}
</style>
